<template>
  <!-- Breadcrumb -->
  <div class="breadcrumb-bar-two breadcrumb-bar-two--search">
    <div class="container">
      <div class="row align-items-center inner-banner">
        <div class="col-md-5 col-12">
          <h2 class="breadcrumb-title">{{ $t(title) }}</h2>
          <nav aria-label="breadcrumb" class="page-breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">{{ $t(text) }}</router-link>
              </li>
              <li class="breadcrumb-item" aria-current="page">{{ $t(text1) }}</li>
            </ol>
          </nav>
        </div>
        <div class="col-md-7 col-12 breadcrumb-search">
          <doctor-search-bar compact :initial-query="queryParam" :remember-city="$route.name !== 'search'" />
        </div>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->
</template>

<script>
import DoctorSearchBar from "@/components/frontend/DoctorSearchBar.vue";

export default {
  components: { DoctorSearchBar },
  props: {
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    text1: {
      type: String,
      default: "",
    },
    queryParam: {
      type: Object,
      default: () => ({
        filter: "",
        city: "",
        city_id: "",
      }),
    }
  }
};
</script>

<style>
/* The theme's overflow: hidden would clip the search dropdowns. */
.breadcrumb-bar-two.breadcrumb-bar-two--search {
  overflow: visible;
  overflow-x: clip;
  z-index: 2;
}

.breadcrumb-search {
  position: relative;
  z-index: 5;
}

@media (max-width: 767.98px) {
  .breadcrumb-search {
    margin-top: 16px;
  }
}
</style>
